import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';

const resources = {
  tr: {
    translation: {
      nav: {
        books: "Kitaplar",
        authors: "Yazarlar",
        company: "Şirket",
        search: "Ara"
      },
      auth: {
        login: "Giriş Yap",
        logout: "Çıkış Yap"
      },
      home: {
        title: "21. yüzyıl için yayıncılık.",
        subtitle: "İnsan Yayınları'nın ana bölümleri:",
        latestReleases: "Son Yayınlar",
        viewAllBooks: "Tüm kitapları görüntüle",
        newReleases: "Yeni Çıkanlar",
        reprints: "Yeni Baskılar",
        bestSellers: "Çok Satanlar",
        viewAll: "Tümünü Gör",
        loading: "Yükleniyor...",
        noBooksFound: "Kitap bulunamadı"
      },
      books: {
        title: "Kitaplar",
        subtitle: "kitap ile geniş koleksiyonumuzu keşfedin.",
        search: "Kitap, yazar ara...",
        searchPlaceholder: "Kitap, yazar ara...",
        showing: "kitap gösteriliyor",
        showingCount: "{{count}} kitap gösteriliyor",
        hasMore: "(daha fazla var)",
        in: "",
        noBooks: "Arama kriterlerinize uygun kitap bulunamadı.",
        clearFilters: "Filtreleri Temizle",
        filters: "Filtreler",
        sort: "Sırala",
        newest: "En Yeni",
        oldest: "En Eski",
        loadMore: "Daha Fazla Yükle",
        loading: "Yükleniyor...",
        retry: "Tekrar Dene",
        errorLoading: "Kitaplar yüklenirken hata oluştu. Lütfen tekrar deneyin.",
        brand: "Marka",
        series: "Dizi",
        allBrands: "Tüm Markalar",
        allSeries: "Tüm Diziler",
        gridView: "Grid görünümü",
        listView: "Liste görünümü",
        noCover: "Kapak Yok"
      },
      authors: {
        title: "Yazarlarımız",
        subtitle: "yetenekli yazarımızla tanışın.",
        search: "Yazar ara...",
        showing: "yazar gösteriliyor",
        noAuthors: "Aradığınız yazar bulunamadı.",
        clearSearch: "Aramayı Temizle",
        books: "kitap",
        viewProfile: "Detaylı bilgi →"
      },
      bookDetail: {
        backToBooks: "Kitaplara Dön",
        author: "Yazar",
        authors: "Yazarlar",
        translator: "Çevirmen",
        published: "Yayın Tarihi",
        pages: "sayfa",
        aboutBook: "Kitap Hakkında",
        bookInfo: "Kitap Bilgileri",
        isbn: "ISBN",
        pageCount: "Sayfa Sayısı",
        category: "Kategori",
        publishYear: "Yayın Yılı",
        bookNumber: "Kitap No",
        relatedBooks: "Benzer Kitaplar",
        seriesBooks: "Aynı Serideki Kitaplar",
        authorOtherBooks: "Yazarın Diğer Kitapları",
        loading: "Kitap yükleniyor...",
        notFound: "Kitap bulunamadı",
        price: "Fiyat",
        addToCart: "Sepete Ekle",
        outOfStock: "Stokta Yok",
        inStock: "Stokta Var",
        description: "Açıklama",
        details: "Detaylar",
        brand: "Marka",
        series: "Seri",
        dimensions: "Boyutlar",
        paperType: "Kağıt Türü"
      },
      authorDetail: {
        backToAuthors: "Yazarlara Dön",
        published: "kitap yayınlandı",
        contact: "İletişim Bilgileri",
        email: "E-posta:",
        phone: "Telefon:",
        authorBooks: "ın Kitapları",
        noBooks: "Bu yazar için henüz kitap bulunmamaktadır."
      },
      footer: {
        tagline: "21. yüzyıl için yayıncılık.",
        quickLinks: "Hızlı Bağlantılar",
        information: "Bilgi",
        tradeInfo: "Ticaret Bilgileri",
        contact: "İletişim",
        privacy: "Gizlilik Politikası",
        followUs: "Bizi Takip Edin",
        rights: "Tüm hakları saklıdır."
      },
      loading: "Yükleniyor...",
      loadingBooks: "Kitaplar yükleniyor...",
      loadingAuthors: "Yazarlar yükleniyor...",
      loadingBook: "Kitap yükleniyor...",
      loadingAuthor: "Yazar yükleniyor..."
    }
  },
  en: {
    translation: {
      nav: {
        books: "Books",
        authors: "Authors",
        company: "Company",
        search: "Search"
      },
      auth: {
        login: "Login",
        logout: "Logout"
      },
      home: {
        title: "Publishing for the 21st century.",
        subtitle: "İnsan Yayınları main divisions:",
        latestReleases: "Latest Releases",
        viewAllBooks: "View all books",
        newReleases: "New Releases",
        reprints: "Reprints",
        bestSellers: "Best Sellers",
        viewAll: "View All",
        loading: "Loading...",
        noBooksFound: "No books found"
      },
      books: {
        title: "Books",
        subtitle: "books in our extensive collection.",
        search: "Search by book or author...",
        searchPlaceholder: "Search book, author...",
        showing: "books showing",
        showingCount: "{{count}} books showing",
        hasMore: "(more available)",
        in: "in",
        noBooks: "No books found matching your criteria.",
        clearFilters: "Clear Filters",
        filters: "Filters",
        sort: "Sort",
        newest: "Newest",
        oldest: "Oldest",
        loadMore: "Load More",
        loading: "Loading...",
        retry: "Retry",
        errorLoading: "Error loading books. Please try again.",
        brand: "Brand",
        series: "Series",
        allBrands: "All Brands",
        allSeries: "All Series",
        gridView: "Grid view",
        listView: "List view",
        noCover: "No Cover"
      },
      authors: {
        title: "Our Authors",
        subtitle: "talented authors.",
        search: "Search authors...",
        showing: "authors showing",
        noAuthors: "No authors found matching your search.",
        clearSearch: "Clear Search",
        books: "books",
        viewProfile: "View profile →"
      },
      bookDetail: {
        backToBooks: "Back to Books",
        author: "Author",
        authors: "Authors",
        translator: "Translator",
        published: "Publication Date",
        pages: "pages",
        aboutBook: "About this book",
        bookInfo: "Book Details",
        isbn: "ISBN",
        pageCount: "Page Count",
        category: "Category",
        publishYear: "Publication Year",
        bookNumber: "Book No",
        relatedBooks: "Related Books",
        seriesBooks: "Books in This Series",
        authorOtherBooks: "Other Books by Author",
        loading: "Loading book...",
        notFound: "Book not found",
        price: "Price",
        addToCart: "Add to Cart",
        outOfStock: "Out of Stock",
        inStock: "In Stock",
        description: "Description",
        details: "Details",
        brand: "Brand",
        series: "Series",
        dimensions: "Dimensions",
        paperType: "Paper Type"
      },
      authorDetail: {
        backToAuthors: "Back to Authors",
        published: "books published",
        contact: "Contact Information",
        email: "Email:",
        phone: "Phone:",
        authorBooks: "'s Books",
        noBooks: "No books available for this author yet."
      },
      footer: {
        tagline: "Publishing for the 21st century.",
        quickLinks: "Quick Links",
        information: "Information",
        tradeInfo: "Trade Information",
        contact: "Contact Us",
        privacy: "Privacy Policy",
        followUs: "Follow Us",
        rights: "All rights reserved."
      },
      loading: "Loading...",
      loadingBooks: "Loading books...",
      loadingAuthors: "Loading authors...",
      loadingBook: "Loading book...",
      loadingAuthor: "Loading author..."
    }
  },
  ar: {
    translation: {
      nav: {
        books: "الكتب",
        authors: "المؤلفون",
        company: "الشركة",
        search: "بحث"
      },
      auth: {
        login: "تسجيل الدخول",
        logout: "تسجيل الخروج"
      },
      home: {
        title: "النشر للقرن الحادي والعشرين.",
        subtitle: "كانيلو لديه ثلاثة أقسام رئيسية:",
        latestReleases: "أحدث الإصدارات",
        viewAllBooks: "عرض جميع الكتب",
        newReleases: "إصدارات جديدة",
        reprints: "طبعات جديدة",
        bestSellers: "الأكثر مبيعاً",
        viewAll: "عرض الكل",
        loading: "جاري التحميل...",
        noBooksFound: "لم يتم العثور على كتب"
      },
      books: {
        title: "الكتب",
        subtitle: "كتاب في مجموعتنا الواسعة.",
        search: "البحث عن طريق الكتاب أو المؤلف...",
        searchPlaceholder: "ابحث عن كتاب، مؤلف...",
        showing: "كتاب معروض",
        showingCount: "{{count}} كتاب معروض",
        hasMore: "(المزيد متاح)",
        in: "في",
        noBooks: "لم يتم العثور على كتب مطابقة لمعاييرك.",
        clearFilters: "مسح الفلاتر",
        filters: "الفلاتر",
        sort: "ترتيب",
        newest: "الأحدث",
        oldest: "الأقدم",
        loadMore: "تحميل المزيد",
        loading: "جاري التحميل...",
        retry: "إعادة المحاولة",
        errorLoading: "خطأ في تحميل الكتب. يرجى المحاولة مرة أخرى.",
        brand: "العلامة التجارية",
        series: "السلسلة",
        allBrands: "جميع العلامات",
        allSeries: "جميع السلاسل",
        gridView: "عرض الشبكة",
        listView: "عرض القائمة",
        noCover: "لا يوجد غلاف"
      },
      authors: {
        title: "مؤلفونا",
        subtitle: "مؤلف موهوب.",
        search: "البحث عن المؤلفين...",
        showing: "مؤلف معروض",
        noAuthors: "لم يتم العثور على مؤلفين مطابقين لبحثك.",
        clearSearch: "مسح البحث",
        books: "كتب",
        viewProfile: "عرض الملف الشخصي ←"
      },
      bookDetail: {
        backToBooks: "العودة إلى الكتب",
        author: "المؤلف",
        authors: "المؤلفون",
        translator: "المترجم",
        published: "تاريخ النشر",
        pages: "صفحة",
        aboutBook: "عن هذا الكتاب",
        bookInfo: "تفاصيل الكتاب",
        isbn: "ISBN",
        pageCount: "عدد الصفحات",
        category: "الفئة",
        publishYear: "سنة النشر",
        bookNumber: "رقم الكتاب",
        relatedBooks: "كتب ذات صلة",
        seriesBooks: "كتب في هذه السلسلة",
        authorOtherBooks: "كتب أخرى للمؤلف",
        loading: "جاري تحميل الكتاب...",
        notFound: "الكتاب غير موجود",
        price: "السعر",
        addToCart: "أضف إلى السلة",
        outOfStock: "غير متوفر",
        inStock: "متوفر",
        description: "الوصف",
        details: "التفاصيل",
        brand: "العلامة التجارية",
        series: "السلسلة",
        dimensions: "الأبعاد",
        paperType: "نوع الورق"
      },
      authorDetail: {
        backToAuthors: "العودة إلى المؤلفين",
        published: "كتب منشورة",
        contact: "معلومات الاتصال",
        email: "البريد الإلكتروني:",
        phone: "الهاتف:",
        authorBooks: "كتب",
        noBooks: "لا توجد كتب متاحة لهذا المؤلف بعد."
      },
      footer: {
        tagline: "النشر للقرن الحادي والعشرين.",
        quickLinks: "روابط سريعة",
        information: "معلومات",
        tradeInfo: "معلومات التجارة",
        contact: "اتصل بنا",
        privacy: "سياسة الخصوصية",
        followUs: "تابعنا",
        rights: "جميع الحقوق محفوظة."
      },
      loading: "جاري التحميل...",
      loadingBooks: "جاري تحميل الكتب...",
      loadingAuthors: "جاري تحميل المؤلفين...",
      loadingBook: "جاري تحميل الكتاب...",
      loadingAuthor: "جاري تحميل المؤلف..."
    }
  }
};

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources,
    fallbackLng: 'tr',
    detection: {
      order: ['localStorage', 'navigator', 'htmlTag', 'path', 'subdomain'],
      caches: ['localStorage'],
      lookupLocalStorage: 'i18nextLng'
    },
    interpolation: {
      escapeValue: false
    }
  });

// Load translations from API and merge with defaults
const API_URL = typeof window !== 'undefined' ? window.location.origin : '';
export const loadTranslationsFromAPI = async (langCode) => {
  try {
    const response = await fetch(`${API_URL}/api/translations/by-language/${langCode}`);
    if (response.ok) {
      const data = await response.json();
      if (data.translation) {
        // Deep merge with existing translations
        i18n.addResourceBundle(langCode, 'translation', data.translation, true, true);
      }
    }
  } catch (e) {
    // Silently fail - fallback to hardcoded translations
  }
};

// Auto-load translations for current language
if (API_URL) {
  const currentLang = i18n.language || 'tr';
  loadTranslationsFromAPI(currentLang);
  i18n.on('languageChanged', (lng) => {
    loadTranslationsFromAPI(lng);
  });
}

export default i18n;